import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFirebaseCRUD } from '../../hooks/useFirebaseCRUD'
import { useForm, useError } from '../../hooks'
import DropdownField from '../Form/DropdownField'
import TextField from '../Form/TextField'
import Button from '../Button'
import ContextMenu from '../ContextMenu'
import Columns from '../Columns'
import Spinner from '../Spinner'

export default function ({ userId }) {
  const navigate = useNavigate()
  const { getDocument, getCollection, updateDocument, loading } = useFirebaseCRUD()
  const [user, setUser] = useState(null)
  const [response, setResponse] = useState(null)
  const setError = useError()
  const [getFieldProps, formData, formError] = useForm({dependencies: [response]})

  useEffect(() => {
    async function fetchData() {
      try {
        const fetchedUser = await getDocument(`users/${userId}`)
        if (!fetchedUser) throw new Error('User not found')
        setUser(fetchedUser)

        const types = await getCollection('userTypes')
        setResponse({ items: types })
      } catch (err) {
        console.error(err)
        setError(err)
      }
    }
    fetchData()
  }, [userId])

  if (loading || !user) return <Spinner />

  async function handleSubmit(e) {
    e.preventDefault()
    try {
      if (!formData.userTypeId) throw new Error('validation_error')

      const userTypeDoc = await getDocument(`userTypes/${formData.userTypeId}`)
      if (!userTypeDoc) throw new Error('validation_error')

      await updateDocument(`users/${user.id}`, {
        userType: {
          ...userTypeDoc, 
          id: formData.userTypeId
        }
      })

      navigate(`/users/${userId}`)
    } catch (err) {
      if (err.message === 'validation_error') {
        formError({ userTypeId: 'Please select a valid user type' })
      } else {
        console.error(err)
        setError(err)
      }
    }
  }

  if (!response) return <Spinner />
  const userTypes = response.items

  return (
    <div className='box'>
      <form onSubmit={handleSubmit}>
        <Columns>
          <TextField
            label='Organization'
            value={user.organization.name}
            readOnly={true}
            required={true}
          />
          <TextField
            label='User'
            value={user.email}
            readOnly={true}
            required={true}
          />
        </Columns>
        <DropdownField
          name='userTypeId'
          label='User Type'
          required={true}
          defaultValue={user?.userType?.id || ''}
          {...getFieldProps()}
        >
          {!userTypes && <option />}
          {userTypes.map((userType) => (
            <option key={userType.id} value={userType.id}>
              {userType.name}
            </option>
          ))}
        </DropdownField>
        <div className='flex justify-end'>
          <Button type='submit'>Assign</Button>
        </div>
      </form>
    </div>
  )
}
